import {DropdownTagMenuItem, showNotification} from 'platform/components';
import {Nullish} from 'utility-types';

import {isNil} from 'ramda';

import {useBlockUserMutation, useUnblockUserMutation} from '@dms/api/customer';
import {UserResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {buildArray} from 'shared/web';

export const useUserActivationDropdownParams = (user: UserResponseBody | Nullish) => {
  const [blockUser, {isLoading: isBlocking}] = useBlockUserMutation();
  const [unblockUser, {isLoading: isUnblocking}] = useUnblockUserMutation();

  const isUserBlocked = user?.blocked ?? false;

  const handleBlockUser = () => {
    if (isNil(user)) {
      throw new Error('User is not defined');
    }

    blockUser({userId: user?.id})
      .unwrap()
      .then(() => showNotification.success(i18n.t('general.notifications.blockedSuccess')))
      .catch(handleApiError);
  };

  const handleUnblockUser = () => {
    if (isNil(user)) {
      throw new Error('User is not defined');
    }

    unblockUser({userId: user?.id})
      .unwrap()
      .then(() => showNotification.success(i18n.t('general.notifications.unblockedSuccess')))
      .catch(handleApiError);
  };

  const dropdownItems = buildArray<DropdownTagMenuItem>()
    .when(isUserBlocked, {
      label: i18n.t('general.actions.activate'),
      onClick: handleUnblockUser,
    })
    .whenNot(isUserBlocked, {
      label: i18n.t('general.actions.deactivate'),
      onClick: handleBlockUser,
    });

  const colorScheme = isUserBlocked ? 'red' : 'green';
  const isLoading = isBlocking || isUnblocking;
  const label = isUserBlocked
    ? i18n.t('general.labels.blocked')
    : i18n.t('entity.settings.labels.active');

  return {label, dropdownItems, colorScheme, isLoading} as const;
};
